import React, { useEffect, useRef, useState } from 'react';
import { VncScreen } from 'react-vnc'
import WindowPortal from './WindowPortal';
import DeviceOfflineOverlay from './DeviceOfflineOverlay';
import useHostReachability from '../utils/useHostReachability';

const VNCViewer = ({ url, host, onClose, title = 'VNC Session', deviceOnline = true, deviceName }) => {
  const screenRef = useRef();
  const [disconnected, setDisconnected] = useState(false);

  // Probe the device only while something is wrong (connection dropped, or
  // the polled status says offline) — the live TCP dial answers in seconds
  // where the polled Tailscale status can lag by minutes. react-vnc's own
  // retry timer keeps reconnecting, so all we add is the explanation.
  const probeReachable = useHostReachability(host, disconnected || !deviceOnline);
  const deviceLost =
    probeReachable === false || (!deviceOnline && probeReachable !== true);


  return (
    <WindowPortal title={title} onClose={onClose}>
    <div
      style={{
        width: '100%',
        height: '100%',
        background: '#000',
        position: 'relative',
        fontFamily: 'sans-serif',
      }}
    >
      <VncScreen
        url={url}
        scaleViewport
        background="#000"
        style={{ width: '100vw', height: '100vh' }}
        ref={screenRef}
        onConnect={() => setDisconnected(false)}
        onDisconnect={() => setDisconnected(true)}
      />

      {deviceLost && (
        <DeviceOfflineOverlay deviceName={deviceName} onClose={onClose} />
      )}
    </div>
  </WindowPortal>
  );
};

export default VNCViewer;
